// extracted by mini-css-extract-plugin
module.exports = {"c7n-tabs-nav":"c7n-tabs-nav","c7n-tabs-bar":"c7n-tabs-bar","c7n-pro-table-wrapper":"c7n-pro-table-wrapper","c7n-pro-table-pagination":"c7n-pro-table-pagination"};